var React = require('react');

function FeatureGroomed (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M13.5 4.629L4.682 13.5H2.56L13.5 2.508v2.121zm0 4.243L8.924 13.5h-2.12L13.5 6.75v2.122zm0 3.878a.75.75 0 0 1-.75.75h-1.704l2.454-2.507v1.757zm-12-2.485L10.318 1.5h2.122L1.5 12.386v-2.12zm0-4.243L6.076 1.5h2.12L1.5 8.143v-2.12zm0-3.772a.75.75 0 0 1 .75-.75h1.704L1.5 3.9V2.25zM13.5 0h-12A1.5 1.5 0 0 0 0 1.5v12A1.5 1.5 0 0 0 1.5 15h12a1.5 1.5 0 0 0 1.5-1.5v-12A1.5 1.5 0 0 0 13.5 0z","fillRule":"evenodd"}));
}

FeatureGroomed.defaultProps = {"role":"presentation","viewBox":"0 0 16 16"};

module.exports = FeatureGroomed;

FeatureGroomed.default = FeatureGroomed;
